import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { UserService } from '@gms/user-api';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import {
  EPasswordResetActions,
  ResetPassword,
  ResetPasswordFailure,
  ResetPasswordSuccess,
} from './password-reset.actions';

@Injectable()
export class PasswordResetEffects {
  constructor(private _actions$: Actions, private _userService: UserService) {}

  ResetPassword: Observable<any> = createEffect(() =>
    this._actions$.pipe(
      ofType<ResetPassword>(EPasswordResetActions.ResetPassword),
      map((action: ResetPassword) => action.payload),
      switchMap(payload => {
        // Architecture decision (Req 7 / Req 8):
        // The multi-step Password_Reset_Flow (lock account → disable MFA → initiate
        // Cognito reset → re-enable MFA → unlock account) is entirely backend-owned.
        // This single forgotPassword() call triggers that server-side flow atomically.
        //
        // Frontend responsibilities:
        //   1. Dispatch this action regardless of whether the username is valid
        //      (anti-enumeration: the UI always shows the same generic locked-account
        //      message — see Req 7 AC7 / Req 8 AC2).
        //   2. Treat both ResetPasswordSuccess and ResetPasswordFailure the same way
        //      in the UI so no backend outcome is leaked to the caller.
        return this._userService.forgotPassword({ username: payload.userId }).pipe(
          map(() => new ResetPasswordSuccess()),
          catchError(error => of(new ResetPasswordFailure({ error: error })))
        );
      })
    )
  );
}
